import { render, staticRenderFns } from "./vehicle.vue?vue&type=template&id=7ed85163&scoped=true&"
import script from "./vehicle.vue?vue&type=script&lang=js&"
export * from "./vehicle.vue?vue&type=script&lang=js&"
import style0 from "./vehicle.vue?vue&type=style&index=0&id=7ed85163&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed85163",
  null
  
)

export default component.exports